<template>
  <div>
    <form action="#" @submit.prevent="signup">
      <p class='text--bold'>Sign up</p>
      <div class="form-field">
          <label for="firstname">First name<strong>*</strong></label>
          <input type="text" required id="firstname" name="firstname" v-model.lazy.trim="firstname" :disabled="authStatus.isRunning">
          <transition name="fade">
            <p v-if="error.firstname" class="error-message">{{error.firstname}}</p>
          </transition>
      </div>

      <div class="form-field">
          <label for="lastname">Last name<strong>*</strong></label>
          <input type="text" required id="lastname" name="lastname" v-model.lazy.trim="lastname" :disabled="authStatus.isRunning">
          <transition name="fade">
            <p v-if="error.lastname" class="error-message">{{error.lastname}}</p>
          </transition>
      </div>

      <div class="form-field">
          <label for="emailAddress">Email<strong>*</strong></label>
          <input type="text" required id="emailAddress" name="emailAddress" v-model.lazy.trim="email" :disabled="authStatus.isRunning">
          <transition name="fade">
            <p v-if="error.email" class="error-message">{{error.email}}</p>
          </transition>
      </div>

      <div>
        <transition name="fade">
          <p v-if="authStatus.hasFailed && authStatus.authSource === 'tinybeans'" class="error-message">
            <span v-if="authStatus.message != 'Validation Error (Email already used)'">{{authStatus.message}}</span>
            <span v-else>
              This email already exists. Please <router-link to="login">login</router-link> instead.
            </span>
          </p>
        </transition>
        <button id="loginButton" type="submit" class="btn btn-login" :disabled="authStatus.isRunning || disableBtn">Continue</button>
      </div>
      <div id="g-recaptcha" style="margin: 8px auto;">
      </div>
    </form>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import ENV from '@/config/environment';
import { signupWithTinybeans } from '@/helpers/Auth';
import { validateEmail, getReferralCode, getCampaignCode, getabTest } from '@/helpers/helpers';
import { redirectToResetPassword } from '@/helpers/helpersUsingStore';

export default {
  name: 'SignupForm',
  data: function() {
    return {
      email: '',
      firstname: '',
      lastname: '',
      disableBtn: false,
      error: {
        email: '',
        firstname: '',
        lastname: '',
      }
    };
  },
  computed: {
    ...mapGetters([
      'authStatus',
    ])
  },
  methods: {
    signup: async function() {
      let hasErrors = false;

      [
        { fieldName: 'email', fieldValue: this.email, errorMsg: 'Email address is required' },
        { fieldName: 'firstname', fieldValue: this.firstname, errorMsg: 'Firstname is required' },
        { fieldName: 'lastname', fieldValue: this.lastname, errorMsg: 'Last name is required' },
      ].forEach(({ fieldName, fieldValue, errorMsg}) => {
        if (!fieldValue) {
          this.error[fieldName] = errorMsg;
          hasErrors = true;
        }
      });

      if(!hasErrors) {
        const credentials = {
          emailAddress: this.email,
          username: this.email,
          firstName: this.firstname,
          lastName: this.lastname,
          clientId: ENV.clientId,
          campaign: getCampaignCode(),
          dateStyle: moment()
                    .localeData()
                    .longDateFormat('L')
                    .toUpperCase()
                    .replace(/\//g, ''),
          referralCode: getReferralCode(),
          abTest: getabTest(),
          sendResetPassword: true,
          sendWelcome: true,
        };

        await signupWithTinybeans(credentials);              
      }    
    },
    disableSubmitBtn: function() {
      this.disableBtn = true;
    },
    enableSubmitBtn: function() {
      this.disableBtn = false;
    },
    redirectToResetPassword: redirectToResetPassword
  },
  watch: {
    email: function() {
      if(!validateEmail(this.email)) {
        this.error.email = 'Email address is invalid';
        this.disableSubmitBtn();
      } else {
        this.error.email = '';
        this.enableSubmitBtn();
      }
    },
    firstname: function() {
      if(this.firstname.length < 2) {
        this.error.firstname = 'Your first name is too short';
        this.disableSubmitBtn();
      } else {
        this.error.firstname = '';
        this.enableSubmitBtn();
      }
    },
    lastname: function() {
      if(this.lastname.length < 2) {
        this.error.lastname = 'Your last name is too short';
        this.disableSubmitBtn();
      } else {
        this.error.lastname = '';
        this.enableSubmitBtn();
      }
    }
  }
}
</script>